export enum SampleDocumentTypeEnum {
  BULLETIN = "BULLETIN"
}